// 1-hour session types
const SessionTypes = {
  mock: {
    name: 'Mock Interview',
    AirtableService: 'Mock Interviews',
    value: 'mock',
    description: 'Practice interviewing and get feedback from your coach.',
  },
  career: {
    name: 'Career Coaching',
    AirtableService: 'Career Coaching',
    value: 'career',
    description: 'Navigate career goals, role transitions, promotions, and more.',
  },
  negotiation: {
    name: 'Negotiation Coaching',
    AirtableService: 'Negotiation',
    value: 'negotiation',
    description: 'Maximize your offer with guidance from a professional negotiator.',
  },
  communication: {
    name: 'Communication Coaching',
    AirtableService: 'Communication Skills',
    value: 'communication',
    description: 'Become a more effective speaker during interviews, meetings, 1:1s, and more.',
  },
  presentation: {
    name: 'Mock Presentation',
    AirtableService: 'Communication Skills',
    value: 'presentation',
    description: 'Practice delivering your presentation and receive actionable feedback.',
  },
};

const SessionStatus = {
  BOOKED: 'booked',
  CANCELED: 'canceled',
  COMPLETED: 'completed',
  INCOMPLETE: 'incomplete',
  DELETED: 'deleted',
};

const SessionStatusDetail = {
  COACH_NO_SHOW: 'coach-no-show',
  STUDENT_NO_SHOW: 'student-no-show',
  COACH_CANCEL: 'coach-canceled',
  STUDENT_CANCEL: 'student-canceled',
  COACH_LATE_CANCEL: 'coach-canceled-late',
  STUDENT_LATE_CANCEL: 'student-canceled-late',
  HIDE_RATING: 'hide-rating',
};

// Displayed in the coach list and can be booked
const CoachAvailableStatuses = [
  'Active',
];

// Displayed in the coach list to admin users and can be booked by admin users
const CoachAvailableStatusesAdmin = [
  'Active',
  'Test',
];

// Not displayed in the coach list and can not be booked, but their profile pages still exist
const CoachAwayStatuses = [
  'Away',
  'Suspended',
  'Calendly error',
];

module.exports = {
  SessionTypes,
  SessionStatus,
  SessionStatusDetail,
  CoachAvailableStatusesAdmin,
  CoachAvailableStatuses,
  CoachAwayStatuses,
};
